<template>
  <!-- CPAP 処方中止 -->
  <div id="CpapCancelDetail">
    <div :id="getContainerType()">
      <div class="labelTitle lable">CPAP 処方中止</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <!--<span style="font-size:20px;">機器情報</span>-->
          <table :set="returnSourceInfo = getReturnSourceInfo()">
            <tr v-if="!isHospital && !isDealer">
              <!--社内ユーザーのみ表示-->
              <th>契約終了日<span class="require"/></th>
              <td><input type="date" v-model="data.contractEndDate" :min="data.contractEndMin" style="width:150px;" class="1" name="契約終了日" validate="required|date" /></td>
            </tr>
            <tr v-if="!isHospital && !isDealer">
              <!--社内ユーザーのみ表示-->
              <th>当月請求<span class="require"/></th>
              <td>
                <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.billingCurrentMonth">
                  <option v-for="billed in billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.text }}</option>
                </select>
              </td>
            </tr>
            <tr v-if="!isHospital && !isDealer">
              <th>中止理由<span class="require"/></th>
              <td>
                <select v-model="data.cancelReasonCode" class="1" name="中止理由" validate="required">
                  <option></option>
                  <option v-for="cancelCode in cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.text }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="vertical-align:top;">中止理由コメント</th>
              <td>
                <textarea maxlength="256" style="resize:vertical;max-width:100%;height:60px;" v-model="data.cancelReasonText"></textarea>
              </td>
            </tr>
            <tr v-if="!isHospital && !isDealer" >
              <!--社内ユーザーのみ表示-->
              <th>回収先<span class="require"/></th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" name="回収先" v-model="data.collectionDestination" :native-value="0">支店回収</b-radio>
                  <b-radio class="td_radio" name="回収先" v-model="data.collectionDestination" :native-value="1">川越回収</b-radio>
                </div>
              </td>
            </tr>
            <tr>
              <th>機器回収先<span class="require"/></th>
              <td>
                <div class="block">
                  <b-radio class="td_radio" name="機器回収先" v-model="data.returnSource" :native-value="0">患者宅</b-radio>
                  <b-radio class="td_radio" name="機器回収先" v-model="data.returnSource" :native-value="1">医療機関</b-radio>
                </div>
              </td>
            </tr>
            <tr><th>【機器回収先住所】</th></tr>
            <tr>
              <th>郵便番号<span class="require"/></th>
              <td>
                <input
                  style="width: 270px;"
                  v-model="returnSourceInfo.zip"
                  class="1"
                  :class="{'border-red': invalidPostcode}"
                  name="郵便番号"
                  validate="required|numeric"
                  maxlength="7"
                  :placeholder="postcodePlaceholder"
                />
                <b-button
                  style="margin-left: 10px; width: 150px; height: 27px;"
                  v-on:click="addressSearch(returnSourceInfo)">郵便番号検索
                </b-button>
                <!-- <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div> -->
                <div v-if= "data.existingFlag" v-show="invalidPostcode" class="text-red"></div>
                <div v-else-if= "!data.existingFlag" v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
            <tr><th>住所<span class="require"/></th><td><input type="text" v-model="returnSourceInfo.address" class="1" name="住所" validate="required" maxlength="280"/></td></tr>
            <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="returnSourceInfo.address1" class="1" name="住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
            <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="returnSourceInfo.address2" maxlength="256"/></td></tr>
            <tr><th>回収先名称<span class="require"/><br>(患者名もしくは医療機関名)</th><td><input type="text" v-model="returnSourceInfo.receiverName" maxlength="100" class="1" name="宛名" validate="required"/></td></tr>
            <tr v-if="returnSourceInfo.mobilePhone">
              <th>連絡先(電話番号)<span class="require"/></th>
              <td>
                <input
                  type="text"
                  v-model="returnSourceInfo.mobilePhone"
                  maxlength="11"
                  class="1"
                  :class="{'border-red': invalidPhoneNumber}"
                  name="連絡先(電話番号)"
                  validate="required|numeric"
                  :placeholder="phonePlaceholder"
                />
                <!-- <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div> -->
                <div v-if= "data.existingFlag" v-show="invalidPhoneNumber" class="text-red"></div>
                <div v-else-if= "!data.existingFlag" v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            <tr v-else>
              <th>連絡先(電話番号)<span class="require"/></th>
              <td>
                <input
                  type="text"
                  v-model="returnSourceInfo.phoneNumber"
                  maxlength="11"
                  class="1"
                  :class="{'border-red': invalidPhoneNumber}"
                  name="連絡先(電話番号)"
                  validate="required|numeric"
                  :placeholder="phonePlaceholder"
                />
                <!-- <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div> -->
                <div v-if= "data.existingFlag" v-show="invalidPhoneNumber" class="text-red"></div>
                <div v-else-if= "!data.existingFlag" v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>

          </table>
        </div>
        <cpapRequestDetail :data="showDetailTargetData" :innerUser="!isHospital && !isDealer" :showRequestInfo="!isHospital && !isDealer" :progress="showDetailTargetData.applicationType" :isEdit="false" v-on:back="back" :deliveryHidden="true" :commentFlg="true"/>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="cancel">申込む</b-button>
        </div>
        <div class="button-area">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  role,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";

export default {
  name: "CpapCancelDetail",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    // getDepositoryCodeMaster: function() {
    //   this.depositoryCodeMaster = []
    //   if(!this.officeCode) return
    //   // Web Api Call
    //   var _this = this;
    //   this.apiCall(
    //     function(client){
    //       return client.apis.apiCommon.getCpapStorageLocationPOST({
    //         body:{
    //           salesOfficeCode: "J"+_this.officeCode
    //         }
    //       });
    //     },
    //     async function(result){
    //       _this.depositoryCodeMaster = result.obj;
    //       var targetOffice = _this.depositoryCodeMaster.find(val => val.depositoryCode=="J"+_this.officeCode)
    //       if(targetOffice){
    //         _this.data.depositoryCode = targetOffice.depositoryCode
    //       }
    //     },
    //     function(result){
    //       _this.showErrorMessage(result);
    //     }
    //   );
    // },
    back: function() {
      if(this.backRoutName){
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
          isEscrow: this.$route.params["isEscrow"],
        });
      }else{
        this.$router.go(-1);
      }
    },
    getReturnSourceInfo :function(){
      return this.data.returnSource == 0 ? this.returnSourceHome: this.returnSourceHospital;
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val.zip
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        val.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        val.address1 = ""
        val.address2 = ""
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    cancel: function() {
      // バリデーションチェック
      if(!this.showDetailTargetData.existingFlag){
        var elements = document.getElementsByClassName(1)
        var result = this.selfMadeValidation(elements)
        if(result.isError){
          this.showErrorMessage(result.msg)
          return
        }
      }
      var messsage = "処方中止を申込みます。<br/>内容を確認して「OK」ボタンを押してください。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "キャンセル",
        onConfirm: async () => {
          this.compleateFlg = true;
          var excuteApi = this.setCpapCancelPrescriptionRequestPOST;
          var successCallBack = this.setCpapCancelPrescriptionRequestPOSTSuccess;
          var errorCallBack = this.setCpapCancelPrescriptionRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.back();
          }
        }
      });
    },
    setCpapCancelPrescriptionRequestPOST: function(client) {

      var obj = JSON.parse(JSON.stringify(this.data));
      obj.receiptNumber = this.showDetailTargetData.receiptNumber
      obj.contractEndDate = obj.contractEndDate ? obj.contractEndDate.replace(/-/g, "/") : ""
      obj.temp = this.temp
      //機器回収先情報をthis.dataに設定する
      let returnSource = this.returnSourceHome;
      if(obj.returnSource != 0){
        returnSource = this.returnSourceHospital;
      }
      obj.zip = returnSource.zip;
      obj.address = returnSource.address;
      obj.address1 = returnSource.address1;
      obj.address2 = returnSource.address2;
      obj.receiverName = returnSource.receiverName;
      obj.phoneNumber = returnSource.mobilePhone ? returnSource.mobilePhone : returnSource.phoneNumber

      return client.apis.externalCpap.setCpapCancelPrescriptionRequestPOST({
        body:obj
      });
    },
    setCpapCancelPrescriptionRequestPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.compleateFlg = true
    },
    setCpapCancelPrescriptionRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    gatCodeMasterList: async function() {
      // CPAP汎用コードマスタリストの取得
      var excuteApi = this.getCpapCodeMasterListPOST;
      var successCallBack = this.getCpapCodeMasterListPOSTSuccess;
      var errorCallBack = this.getCpapCodeMasterListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapCodeMasterListPOST: function(client) {
      return client.apis.apiCommon.getCpapCodeMasterListPOST({
        body:[
          this.cpapCodeMaster.cancellReason,
          this.cpapCodeMaster.billedCurrentMonth
        ]
      });
    },
    getCpapCodeMasterListPOSTSuccess: function(result) {
      this.cancelCodeMaster = result.obj[this.cpapCodeMaster.cancellReason]
      this.billedCurrentMonth = result.obj[this.cpapCodeMaster.billedCurrentMonth]
    },
    getCpapCodeMasterListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back();
    },
  },
  data() {
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var cpapCodeMaster = this.getCpapCodeMaster();
    var backRoutName = this.$route.params["name"];
    var backRoutParams = this.$route.params;
    var showDetailTargetData = this.$route.params["selectedData"];
    showDetailTargetData.instructionDate = this.yyyy_hyp_MM_hyp_dd(new Date())
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var officeCode = userInfo.salesOfficeCode
    // var returnSource =  showDetailTargetData.delivaryTarget == 'hospital' ? 1 : 0
    var returnSource =  0
    var data = {
      cancelReasonCode:"",
      cancelReasonText:"",
      collectionDestination:1,
      returnSource:returnSource,
      contractEndDate:showDetailTargetData.contractEndDate,
      contractEndMin:showDetailTargetData.contractEndMin,
      existingFlag:showDetailTargetData.existingFlag
    }
    let returnSourceHome = {
      zip:showDetailTargetData ? showDetailTargetData.patient.zip : "",
      address:showDetailTargetData ? showDetailTargetData.patient.address : "",
      address1:showDetailTargetData ? showDetailTargetData.patient.address1 : "",
      address2:showDetailTargetData ? showDetailTargetData.patient.address2 : "",
      receiverName:showDetailTargetData ? showDetailTargetData.patient.receiverName : "",
      phoneNumber:showDetailTargetData ? showDetailTargetData.patient.phoneNumber : "",
      mobilePhone:showDetailTargetData ? showDetailTargetData.patient.mobilePhone : "",
    }
    let returnSourceHospital = {
      zip:showDetailTargetData ? showDetailTargetData.zip : "",
      address:showDetailTargetData ? showDetailTargetData.address : "",
      address1:showDetailTargetData ? showDetailTargetData.address1 : "",
      address2:showDetailTargetData ? showDetailTargetData.address2 : "",
      receiverName:showDetailTargetData ? showDetailTargetData.receiverName : "",
      phoneNumber:showDetailTargetData ? showDetailTargetData.phoneNumber : "",
      mobilePhone: "",
    }
    return {
      cpapCodeMaster,
      backRoutName,
      backRoutParams,
      showDetailTargetData,
      role: role,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      data,
      returnSourceHome,
      returnSourceHospital,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      cancelCodeMaster:[],
      billedCurrentMonth:[],
      temp,
      officeCode,
      branchOfficeMaster,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      returnSourceInfo: [],
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      isEscrow: "",
    };
  },
  filters: {},
  components: {
    cpapRequestDetail:CpapRequestDetail
  },
  mounted: function() {
    // CPAP汎用コードマスタ取得
    this.gatCodeMasterList()

    this.invalidPostcode = isNaN(Number(this.showDetailTargetData.zip));
    this.invalidPhoneNumber = isNaN(Number(this.showDetailTargetData.phoneNumber));
  },
  watch: {
    "returnSourceInfo.zip"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "returnSourceInfo.mobilePhone"(newValue) {
      if (this.data.returnSource != 1) {
        this.invalidPhoneNumber = isNaN(Number(newValue));
      }
    },
    "returnSourceInfo.phoneNumber"(newValue) {
      if (!this.returnSourceInfo.mobilePhone) {
        this.invalidPhoneNumber = isNaN(Number(newValue));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
.historyTable-area {
    max-height:500px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.historyTable {
    width: 1150px !important;
}
.historyTable .date {
    width:120px !important;
}
.historyTable .operation {
    width:80px !important;
}
.historyTable .detail {
    width:500px !important;
}
.historyTable .operator{
    width:250px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapCancelDetail.vue